module.exports = __webpack_public_path__ + "static/mh-bg-3a89746c2345a423ba31d7086a05d1b1.jpg";